/**
 * Socket-API SSE hub — public live odds stream (no auth key).
 * Same-origin `/api/socket` (nginx + Vite proxy); override via VITE_SOCKET_BASE_URL.
 */

export function getSocketBaseUrl(): string {
  const raw = import.meta.env.VITE_SOCKET_BASE_URL
  if (typeof raw === 'string') {
    const trimmed = raw.trim().replace(/\/$/, '')
    if (trimmed.length > 0) return trimmed
  }
  return '/api/socket'
}

export function hasLiveSocket(): boolean {
  return Boolean(getSocketBaseUrl())
}
